"use client";

import React from "react";
import {useApi, useApiMutation, useTempData, useApiFileDownload} from "@/lib/hook";
import {Button, Card} from "@/theme/ui";
import {Spin, Space, Typography, Flex} from "antd";
import style from './dashboard.module.scss'
import {CalendarIcon} from "@/theme/assets/icons";
import {InfoUsers} from "@/components/dashboard/infoUsers";
import {SupportChart} from "@/components/dashboard/charts/support/supportChart";
import {CountriesChart} from "@/components/dashboard/charts/countries/CountriesChart";
import {SupportTotalChart} from "@/components/dashboard/charts/support/supportTotalChart";
import {SalesChart} from "@/components/dashboard/charts/sales/SalesChart";
import {useTranslations} from "next-intl";
const initFilterData = {
    page: 1,
    type: 'all',
    sales_type: 'connections',
}

export const AllDashboard = () => {
    const t = useTranslations('dashboard');
    const {data: tempData, setTempData} = useTempData('dashboard_all', initFilterData)
    const {fetch: fetchDownload, isFetching: isFetchingDownload} = useApiFileDownload()
    const {data, isFetching, refetch} = useApi({
        route: {name: 'dashboard.all'},
        data: {...tempData}
    })
    const update = useApiMutation({
        onSuccess: () =>{
            refetch()
        }
    })

   const onChangeFilter = (type, value) => {
        setTempData({
            ...tempData,
            [type]: value
        })
   }

    return (
        <>
            <Spin spinning={isFetching || update.isLoading}>
                <Card
                    title={t('title')}
                    className={'purchases dashboard'}
                    extra={(
                        <Space>
                            <Button
                                icon={<CalendarIcon />}
                                className={style.button_date}
                            >
                                {data?.current_month ?? '01.01-31.01'}
                            </Button>
                        </Space>
                    )}
                >
                    <InfoUsers
                        users={data?.new_users}
                    />
                    <Flex
                        justify={"space-between"}
                        style={{marginTop: '20px'}}
                        gap={20}
                        className={'charts'}
                    >
                        <CountriesChart
                            info={data?.top_countries}
                            onChangeFilter={onChangeFilter}
                        />
                        <SupportChart
                            info={data?.ticket_statistics}
                        />
                    </Flex>
                    <Flex
                        justify={"space-between"}
                        style={{marginTop: '20px'}}
                        gap={20}
                        className={'charts'}
                    >
                        <SalesChart
                            info={data?.sales}
                            onChangeFilter={onChangeFilter}
                        />
                        <SupportTotalChart
                            info={data?.support_ticket}
                        />
                    </Flex>
                </Card>
            </Spin>
        </>
    );
}